import * as ChannelService from "@channel.io/channel-web-sdk-loader";
import * as React from "react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import useLanguage from "@hooks/useLanguage";

import { useCustomerStore } from "@store/customer";

const CHANNEL_TALK_KEY = import.meta.env.VITE_REACT_APP_CHANNEL_TALK_PLUGIN_KEY as string;
const CHANNEL_TALK_INTL_KEY = import.meta.env.VITE_REACT_APP_CHANNEL_TALK_INTL_PLUGIN_KEY as string;

export default function ChannelTalk() {
  const { customer } = useCustomerStore();

  const { pathname } = useLocation();

  const { lang } = useLanguage();

  const [isShowChannelTalk, setIsShowChannelTalk] = useState(true); // 메시지창 열리면 아이콘 숨기기

  useEffect(() => {
    ChannelService.setPage(location.href);
    ChannelService.track("PageView");
  }, [location.href]);

  useEffect(() => {
    ChannelService.boot({
      pluginKey: lang === "ko" ? CHANNEL_TALK_KEY : CHANNEL_TALK_INTL_KEY,
      customLauncherSelector: "#channelTalk",
      hideChannelButtonOnBoot: true,
      ...(customer.id && {
        memberId: customer.id.replace(/\D/g, ""),
        profile: {
          name: `${customer.lastName || ""}${customer.firstName || ""}`,
          email: customer.email || "",
          id: customer.id,
        },
      }),
    });
  }, [pathname, customer]);

  ChannelService.onShowMessenger(() => {
    setIsShowChannelTalk(false);
  });

  ChannelService.onHideMessenger(() => {
    setIsShowChannelTalk(true);
  });

  return (
    <>
      {isShowChannelTalk ? (
        <div
          className="flex size-15 cursor-pointer items-center justify-center rounded-full bg-white/90 p-5 shadow dark:bg-black dark:text-white dark:shadow-white"
          id="channelTalk"
        >
          <span className="pointer-events-none">Help</span>
        </div>
      ) : null}
    </>
  );
}
